import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import EventSubscriptionPlanWidget from '@/components/events/plan/event-subscription-plan-widget';

/** Flow settings entry — single: base_capacity; multi: base_capacity_flow + broadcast (+ matching add-ons). */
export default function FlowSubscriptionPlanWidget({
  flow,
  eventSlotId,
}: {
  flow: FlowDto;
  eventSlotId?: string | null;
}) {
  return <EventSubscriptionPlanWidget surface="flow" flow={flow} eventSlotId={eventSlotId} />;
}
